var map = {
	"./de": [
		89972,
		972
	],
	"./de.ts": [
		89972,
		972
	],
	"./en": [
		36490,
		490
	],
	"./en.ts": [
		36490,
		490
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 37921;
module.exports = webpackAsyncContext;